import PropTypes from 'prop-types';
import { useState, useRef, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Alert, DialogActions, Button, Box, Tooltip } from '@mui/material';
import CloseIconButton from '../../../../reusable-components/basic-buttons/CloseIconButton';
import { AwaitButton } from '../../../../reusable-components/await-button';

ConfirmSaveOrderDialog.propTypes = {
  isConfirmSaveDialogOpen: PropTypes.bool,
  setIsConfirmSaveDialogOpen: PropTypes.func,
  itemsModified: PropTypes.array,
  handleCancelSave: PropTypes.func,
  handleSave: PropTypes.func,
};
  
export default function ConfirmSaveOrderDialog({ isConfirmSaveDialogOpen, setIsConfirmSaveDialogOpen, itemsModified, handleCancelSave, handleSave }) {
  
  const DescriptionWithTooltip = ({ text }) => {
    const ref = useRef(null);
    const [showTooltip, setShowTooltip] = useState(false);
    useEffect(() => {
      if (ref.current) {
        setShowTooltip(ref.current.scrollWidth > ref.current.clientWidth);
      }
    }, [text]);
  
    return showTooltip ? (
      <Tooltip title={text} placement="top">
        <Box ref={ref} sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>{text}</Box>
      </Tooltip>
    ) : (
      <Box ref={ref} sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>{text}</Box>
    );
  };

  return <Dialog open={isConfirmSaveDialogOpen} onClose={(event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    setIsConfirmSaveDialogOpen(false);
  }} maxWidth="md" fullWidth>
    <DialogTitle sx={{ textAlign: 'center' }} color="info.main">
      The quantity of one or more punchout items has been changed
      <CloseIconButton onClick={() => setIsConfirmSaveDialogOpen(false)} />
      <Alert severity="warning" sx={{ justifyContent: 'center' }}>
        Modifying the quantity of a punchout item may result in the order being canceled
      </Alert>
    </DialogTitle>
    <DialogContent sx={{ml: 2}}>
      <ul>
        {itemsModified?.map((item) => (
          <li key={item.id}>
            <DescriptionWithTooltip text={item.description} />
            <Box sx={{fontWeight: 'bold'}}>Current Quantity: {item.origQty} | Updated Quantity: {item.quantity}</Box>
          </li>
        ))}
      </ul>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCancelSave} color="primary" variant="text">Cancel</Button>
      <AwaitButton onClick={handleSave} color="primary" variant="contained">Save Changes</AwaitButton>
    </DialogActions>
  </Dialog>;
}